import React from 'react'
import {Container} from 'react-bootstrap'
import withAuth from '../components/authHOC'
import AccountsTable from '../components/AccountsTable'

const LoansPage = () => {
    
  return (
       <Container fluid id='users-container'>
       
        <AccountsTable></AccountsTable>
    </Container>
  )
}
export default withAuth (LoansPage, ['admin', 'agent'])